import './style.css'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import * as loginActions from '../../redux/actions/login.action'

import backIcon from '../../assets/images/go-back-white.svg'
import Logo from '../../assets/images/logo-fwd.svg'
import Logout from '../../assets/images/logout.svg'
import support from '../../assets/images/support.svg'
import { RootReducers } from '../../redux/reducers'
import { StaffMenu } from '../staffMenu'
import { SQDMenu } from '../sqdMenu'
import store from '../../helpers/store'
import { CollectionMenu } from '../collectionMenu'

interface HEADER_BAR_PROPS_TYPE {
  children?: React.ReactNode
  isSummary?: boolean
  isLogin?: boolean
}

export const HeaderBar: React.FC<HEADER_BAR_PROPS_TYPE> = ({ children, isSummary, isLogin }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const loginState = useSelector((state: RootReducers) => state.loginReducer)
  const [showAgingPopup, setshowAgingPopup] = store.useState('showAgingPopup')
  const goBack = () => {
    navigate('/')
  }

  const logout = () => {
    setshowAgingPopup(true)
    dispatch(
      loginActions.handleLogout(loginState.account?.agentInfo.isBranchStaff as boolean, navigate)
    )
  }

  return (
    <div className={isSummary ? 'container-headerBar-summary' : 'container-headerBar'}>
      <div className="row-header">
        <img src={backIcon} alt="goBack" onClick={goBack} />
        <div className={isSummary ? 'white-bar-summary' : 'white-bar'}>
          <img src={Logo} alt="Logo" />
          <div>
            {isSummary && <img src={support} alt="Support" className="icon-support" />}
            {!isSummary && !isLogin && (
              <div className="logout_tooltip" onClick={logout}>
                <span className="logout_tooltiptext" onClick={logout}>
                  ออกจากระบบ
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
      {!isSummary && (
        <div className="content-children">
          <StaffMenu />
          <SQDMenu />
          {/* <CollectionMenu /> */}
          {children}
        </div>
      )}
    </div>
  )
}
